module.exports = __webpack_public_path__ + "media/images/regions/Dosso-4e6ed2104582ee1e4cf5940c92faba32.png";